/* App popups (Klaviyo, geo modal) only run on the homepage and cover the whole
   viewport above the header, so dismissing one reads as a click outside the search
   and closes it. There, outside clicks are ignored until the modal has been open
   this long; every other template closes on an outside click straight away. */
const OUTSIDE_CLOSE_DELAY = 8000;

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  listenForOutsideClick() {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);

    if (!document.body.classList.contains('template--index')) {
      document.body.addEventListener('click', this.onBodyClickEvent);
      return;
    }

    this.outsideClickTimer = setTimeout(() => {
      document.body.addEventListener('click', this.onBodyClickEvent);
    }, OUTSIDE_CLOSE_DELAY);
  }

  open(event) {
    event.target.closest('details').setAttribute('open', true);
    this.listenForOutsideClick();
    document.body.classList.add('overflow-hidden');

    const searchInputEl = document.querySelector('#Search-In-Modal'),
      searchResults = document.querySelector('#predictive-search-results'),
      searchSuggestions = document.querySelectorAll('.predictive-search-suggestions');

    if (searchResults) {
      searchInputEl.value = null;
      searchResults.style.display = 'none';
      searchSuggestions[1].style.display = 'block';
    }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    clearTimeout(this.outsideClickTimer);
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
